 $(document).ready(function () {
    $('.text-slide').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.image-slide',
      autoplay: true,
      autoplaySpeed: 2500,
      speed: 600
    });

    $('.image-slide').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: '.text-slide',
      dots: false,
      arrows: false,
      // variableWidth: true,
      centerMode: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 460,
          settings: {
            slidesToShow: 4
          }
        }
      ]
    });
  });